import { createContext } from 'react';

interface IHealthStatusContext {
  areSystemsAvailable: boolean;
  isPending: boolean;
}

const initialValue: IHealthStatusContext = {
  areSystemsAvailable: false,
  isPending: true,
};

const HealthStatusContext = createContext<IHealthStatusContext>(initialValue);

export default HealthStatusContext;
